<template>
  <div class="flex flex-col min-h-screen">
    
    <HeaderC />

    <main class="grid min-h-full place-items-center bg-slate-50 dark:bg-slate-900 px-6 py-24 sm:py-32 lg:px-8 transition-colors duration-300 flex-grow relative overflow-hidden">
      
      <div aria-hidden="true" class="pointer-events-none absolute inset-0 z-0 overflow-hidden">
        <div class="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 h-[30rem] w-[30rem] rounded-full 
                    bg-blue-100/50 blur-3xl mix-blend-multiply 
                    dark:bg-blue-900/20 dark:mix-blend-normal
                    animate-blob"></div>
      </div>

      <div class="text-center relative z-10">
        <p class="text-base font-bold text-blue-600 dark:text-blue-400">404</p>
        
        <h1 class="mt-4 text-3xl font-black tracking-tight text-slate-900 dark:text-white sm:text-5xl">
          {{ t.title }}
        </h1>
        
        <p class="mt-6 text-base leading-7 text-slate-600 dark:text-slate-400">
          {{ t.desc }}
        </p>
        
        <div class="mt-10 flex items-center justify-center gap-x-6">
          <router-link
            :to="{ name: 'home', params: { langue: currentLang } }"
            class="rounded-xl bg-blue-600 px-3.5 py-2.5 text-sm font-semibold text-white shadow-sm hover:bg-blue-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-blue-600 transition-all"
          >
            {{ t.homeBtn }}
          </router-link>
          
          <router-link 
            :to="{ name: 'contact', params: { langue: currentLang } }"
            class="text-sm font-semibold text-slate-900 dark:text-slate-200 hover:text-blue-600 dark:hover:text-blue-400 transition-colors"
          >
            {{ t.contactBtn }} <span aria-hidden="true">&rarr;</span>
          </router-link>
        </div>
      </div>
    </main>

    <FooterC />
  </div>
</template>

<script>
import { defineComponent, computed } from "vue";
import { useStore } from "vuex";

// Import des composants globaux
import HeaderC from "../components/Visitor_Component/Shared/HighHeader.vue";
import FooterC from "../components/Visitor_Component/Shared/FooterComponent.vue";

export default defineComponent({
  name: "Page404",
  components: { HeaderC, FooterC },
  setup() {
    const store = useStore();

    // Récupération de la langue actuelle
    const currentLang = computed(() => store.getters.getLangue || "fr");

    // Dictionnaire de traduction interne
    const content = {
      fr: {
        title: "Page introuvable",
        desc: "Désolé, nous ne trouvons pas la page que vous cherchez.",
        homeBtn: "Retour à l'accueil",
        contactBtn: "Contactez le support"
      },
      en: {
        title: "Page not found",
        desc: "Sorry, we couldn’t find the page you’re looking for.",
        homeBtn: "Go back Home",
        contactBtn: "Contact support"
      }
    };

    // Texte affiché selon la langue
    const t = computed(() => content[currentLang.value] || content.fr);

    return {
      currentLang,
      t
    };
  },
});
</script>

<style scoped>
/* Animation simple pour le fond */
@keyframes blob {
  0% { transform: translate(-50%, -50%) scale(1); }
  33% { transform: translate(-50%, -60%) scale(1.1); }
  66% { transform: translate(-40%, -50%) scale(0.9); }
  100% { transform: translate(-50%, -50%) scale(1); }
}
.animate-blob {
  animation: blob 10s infinite;
}
</style>